import { useContext, useEffect, useState } from 'react';
import Loader from '../StaticComponent/Loader';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import { getIndividualPolicyDirectoryDetails } from '../service/todo.js';
import { useNavigate } from 'react-router-dom';
import { getTimestampToDate } from '../utils/dateConvetor.js';
import { getS3 } from '../utils/Download.js';
import moment from 'moment';
// import filterValue from './PolicyDirectory.jsx'

export default function IndividualPolicyDirectory() {

    const navigate = useNavigate();
    let search = window.location.search;
    const empid = new URLSearchParams(search).get('employeeId')
    const empName = new URLSearchParams(search).get('emplpoyeeName')
    let individualFilterObj = {
        employeeId: empid,
        search: "",
        acknowlegmentStatus: '',
        createdFromDate: '',
        createdToDate: '',
        modifiedFromDate: '',
        modifiedToDate: '',
    };
    const [directoryData, setDirectoryData] = useState(individualFilterObj);

    const [isLoading, setIsLoading] = useState(false);
    const [hideContainer, setHideContainer] = useState(false);
    const [gridData, setGridData] = useState();
    const [policyURL, setPolicyURL] = useState('');

    //let emp_id = params.get('employeeId');
    // const filterContext=useContext(filterValue);


    //  PC_PD_50 to  PC_PD_59 - sort in ascending and descending
    const [columnOrder, setColumnOrder] = useState('ASC');
    const [columnName, setColumnName] = useState('a.policy_name');
    const [sorthide, setsorthide] = useState('a.policy_name@ASC');

    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'How Do I?', isActive: true, path: '' },
        { title: 'Policy Directory', isActive: true, path: '/PolicyDirectory' },
        { title: `${empName} Directory`, isActive: false, path: '/individualpolicydetail' },
    ];


    useEffect(() => {
        individualPolicyDirectoryDetails();
    }, [sorthide]);


    async function individualPolicyDirectoryDetails() {
        try {
            setIsLoading(false);
            let result = await getIndividualPolicyDirectoryDetails(directoryData);
            setGridData(result?.data);
            setIsLoading(true);
        }
        catch (e) {
            console.log(e.message);
        } finally {
            setIsLoading(true);
        }
    }



    const sortClicked = (e) => {
        try {
            ;
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setDirectoryData({ ...directoryData, sort: sortval[0], order: sortval[1] });
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
        } catch (e) { }
    };

    //     function formatDate(date) {
    //       var d = new Date(date),
    //           month = "" + (d.getMonth() + 1),
    //           day = "" + d.getDate(),
    //           year = d.getFullYear();
    //       if (month.length < 2) month = "0" + month;
    //       if (day.length < 2) day = "0" + day;
    //       return [month, day, year].join("/");
    //   }

    //   const filterclear = () => {
    //     // 
    //   let filterclear = {
    //     employeeId: '',
    //     search: '',
    //     acknowlegmentStatus: '',
    //     createdFromDate: '',
    //     createdToDate: '',
    //     modifiedFromDate: '',
    //     modifiedToDate: '',
    // }
    // setDirectoryData(cleardirectoryObj);
    // setHideContainer(true)
    // }

    // const filterCheck = (e) => {
    //   try {
    //       setHideContainer(hideContainer == true ? false : true);
    //   } catch (e) {}
    // };

    const handleSearch = (e) => {
        try {
            setDirectoryData({
                ...directoryData,
                ["search"]: e.target.value
            })
        } catch (e) { }
    };


    const handleSearchKeyDown = (e) => {

        if (e.key === "Enter") {
            individualPolicyDirectoryDetails();
        }
    };

    const searchClick = () => {
        individualPolicyDirectoryDetails();
    };

    const filterclear = () => {
        setDirectoryData(individualFilterObj);
        setHideContainer(true);
    };

    const filterCheck = () => {
        try {
            ;
            setHideContainer(hideContainer == true ? false : true);
        } catch (error) {
            console.log(error.message, 'issue in onclick of filter');
        }
    };

    function bindIndividualPolicyDirectory() {
        if (gridData?.length == 0) {
            return (
                <tr>
                    <td colSpan={10}>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/vadivelu.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            />
                            <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                        </div>
                    </td>
                </tr>
            );
        }
        else {
            return gridData?.map((value, index) => {
                return (
                    <tr>
                        <td>{value.policy_name} </td>
                        <td>{moment(new Date(value.created_at)).format('MM/DD/YYYY')}</td>
                        <td>{value.acknowlegment_status ? "Yes" : "No"}</td>
                        <td>{value.acknowlegment_status ? moment(new Date(value.modified_at)).format('MM/DD/YYYY') : "NA"}</td>
                        <td>
                            <button className="btn btn-policy-edit box-shadow-none">
                                <a
                                    href="#"
                                    style={{ cursor: "pointer" }}
                                    onClick={async () => {
                                        const url = value?.signed_policy_url ? await getS3(value.signed_policy_url) : await getS3(value.policy_url);
                                        window.open(url, "_blank");
                                    }}
                                >
                                    <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                </a>
                            </button>
                        </td>
                    </tr>
                );
            });
        }
    };




    return (
        <div className="container-fluid mt-5">
            {/* <Loader isLoading={isLoading} /> */}
            <div className="row">
                <div className="col-md-11" style={{ marginTop: '10px' }}>
                    <BreadCrumbs data={breadCrumbsData} />
                </div>
                <div className="col-md-12">
                    <div className="px-4">
                        <div className="d-flex align-items-center justify-content-between mt-3">
                            <div className="d-flex align-items-center">
                                <img src="Images/Policy/arrow-policy.svg" onClick={() => navigate('/policyDirectory')} alt="arrow-policy" className="cursor-pointer" />
                                <h2 className="mb-0 heading-color bold-text font-18 ms-4">{empName}'s Policy Directory</h2>
                            </div>
                            <div>
                                <ul className="nav">
                                    <li>
                                        <div className="input-group flex-nowrap search-group me-2">
                                            <input
                                                type="search"
                                                className="form-control search-align"
                                                placeholder="Search"
                                                aria-label="Username"
                                                aria-describedby="addon-wrapping"
                                                onChange={(e) => { handleSearch(e) }}
                                                onKeyUp={(e) => { handleSearchKeyDown(e) }}
                                            />
                                            <button
                                                className="input-group-text btn btn-search-custom align-items-center d-flex"
                                                id="addon-wrapping"
                                                onClick={() => { searchClick() }}
                                            >
                                                <img src="Images/Policy/todo-find-icon.svg" alt="search-icon" className="todo-find-icon" />
                                            </button>
                                        </div>
                                    </li>
                                    <li>
                                        {/*Filter Section Starts Here*/}
                                        {/* <div className="dropdown">
                                            <button
                                                className="advanced-filter-button me-2 medium-text"
                                                type="button"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <img src="images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                                Filter
                                            </button>
                                            <div className="dropdown-menu custom-filter shadow-sm border-0 p-3">
                                                <div className="col-md-12">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h5 className="font-18 semibold-text text-black mb-0">Advanced Filter</h5>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        />
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label text-black font-14 bold-text"
                                                                    htmlFor="Acknowledgement"
                                                                >
                                                                    Acknowledgement
                                                                </label>
                                                                <select
                                                                    className="form-select cust-input-sty font-14 font-regular"
                                                                    id="Acknowledgement"
                                                                >
                                                                    <option selected>Select</option>
                                                                    <option value={1}>One</option>
                                                                    <option value={2}>Two</option>
                                                                    <option value={3}>Three</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 col-sm-12">
                                                            <div className="mt-3">
                                                                <label className="form-label text-black font-14 bold-text">
                                                                    Published Date
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label text-black font-14 bold-text"
                                                                    htmlFor="startFrom"
                                                                >
                                                                    From
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control cust-input-sty font-14 font-regular"
                                                                    id="startFrom"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label text-black font-14 bold-text"
                                                                    htmlFor="startTo"
                                                                >
                                                                    To
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control cust-input-sty font-14 font-regular"
                                                                    id="startTo"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 col-sm-12">
                                                            <div className="mt-2">
                                                                <label className="form-label text-black font-14 bold-text">
                                                                    Acknowledged On
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label text-black font-14 bold-text"
                                                                    htmlFor="expiryFrom"
                                                                >
                                                                    From
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control cust-input-sty font-14 font-regular"
                                                                    id="expiryFrom"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="mb-3">
                                                                <label
                                                                    className="form-label text-black font-14 bold-text"
                                                                    htmlFor="expiryTo"
                                                                >
                                                                    To
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control cust-input-sty font-14 font-regular"
                                                                    id="expiryTo"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-end mt-4 mb-2">
                                                        <button
                                                            type="button"
                                                            className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                        >
                                                            Clear
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        {/*Filter Section Starts Here*/}

                                        <div className="dropdown">
                                            <button
                                                className="advanced-filter-button me-2 medium-text"
                                                type="button"
                                                id="feedback-filter-dropdown"
                                                data-bs-toggle="dropdown"
                                                onClick={() => {
                                                    filterCheck();
                                                }}

                                            >
                                                <img src="/Images/filter-icon.svg" className="me-2" />
                                                Filter
                                            </button>
                                            {hideContainer && (
                                                <div className="dropdown-menu px-3 advanced-filter-panel" style={{ display: 'block' }}>
                                                    {/* <div className="col-md-12"> */}
                                                    <div className="col-md-12 py-2 border-0 mb-1">
                                                        <span className="font-16 semibold-text advanced-filter-title">
                                                            Advanced Filter
                                                        </span>

                                                        <button
                                                            type="button"
                                                            className="btn-close float-end close-filter"
                                                            data-bs-dismiss="advanced-filter"
                                                            aria-label="Close"
                                                            onClick={() => { setHideContainer(false) }}
                                                        />
                                                    </div>
                                                    <div className="col-md-12 ">
                                                        <div class="col-md-6 col-sm-12">
                                                            <div class="mb-3">
                                                                <label
                                                                    class="form-label hive-form-label"
                                                                    for="approver"
                                                                >
                                                                    Acknowledgement
                                                                </label>
                                                                <select
                                                                    class="form-select hive-form-control"
                                                                    id="approver"
                                                                    value={directoryData.acknowlegmentStatus}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["acknowlegmentStatus"]: e.target.value == "" ? "" : (e.target.value) == "true" ? true : false }); }}

                                                                >
                                                                    <option selected value={""}>Select</option>
                                                                    <option value={true}>Yes</option>
                                                                    <option value={false}>No</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 pb-2 border-0">
                                                            {/* <div className="mt-3"> */}
                                                            <span className="font-14 semibold-text filter-title">Published Date</span>
                                                            {/* </div> */}
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="fromrange"
                                                                >
                                                                    From
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="fromrange"
                                                                    name="startDate"
                                                                    value={directoryData.createdFromDate}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["createdFromDate"]: e.target.value }) }}


                                                                />
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="torange"
                                                                >
                                                                    To
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="torange"
                                                                    name="endDate"
                                                                    value={directoryData.createdToDate}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["createdToDate"]: e.target.value }) }}


                                                                />
                                                            </div>

                                                            <div className="col-md-12 pb-2 border-0">
                                                                {/* <div className="mt-3"> */}
                                                                <span className="font-14 semibold-text filter-title">Acknowledged On</span>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="fromrange"
                                                                >
                                                                    From
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="fromrange"
                                                                    name="startDate"
                                                                    value={directoryData.modifiedFromDate}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["modifiedFromDate"]: e.target.value }) }}

                                                                />
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="torange"
                                                                >
                                                                    To
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="torange"
                                                                    name="endDate"
                                                                    value={directoryData.modifiedToDate}
                                                                    onChange={(e) => { setDirectoryData({ ...directoryData, ["modifiedToDate"]: e.target.value }) }}


                                                                />
                                                            </div>
                                                        </div>
                                                        {/* </div> */}
                                                    </div>
                                                    <div>
                                                        <div className="text-end mt-4 mb-2">
                                                            <button
                                                                type="button"
                                                                className="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3"
                                                                onClick={(e) => {
                                                                    filterclear();
                                                                    setHideContainer(false);
                                                                }}
                                                            >
                                                                Clear
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                                                onClick={() => {
                                                                    setHideContainer(false); individualPolicyDirectoryDetails();

                                                                }}
                                                            >
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                            )}
                                        </div>
                                        {/*Filter Section Ends Here*/}
                                        {/*Filter Section Ends Here*/}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="table-responsive bg-white mt-4 policy-table">
                            <table className="table table-borderless">
                                <thead className="semibold-text font-12">
                                    <tr>
                                        <th>
                                            Policy Name
                                            <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                id="policy_name@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'policy_name@DESC' ? true : false}
                                            />
                                            <img
                                                src="Images/Policy/sort-up.svg"
                                                className="hive-table-sort"
                                                id="policy_name@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'policy_name@DESC' ? false : true}
                                            />
                                        </th>
                                        <th>
                                            Published Date
                                            <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                id="created_at@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'created_at@DESC' ? true : false}
                                            />
                                            <img
                                                src="Images/Policy/sort-up.svg"
                                                className="hive-table-sort"
                                                id="created_at@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'created_at@DESC' ? false : true}
                                            />
                                        </th>
                                        <th>
                                            Acknowledgement
                                            <img
                                                src="Images/Policy/sort-down.svg"
                                                alt="sort-down"
                                                className="cursor-pointer"
                                                id="acknowlegment_status@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'acknowlegment_status@DESC' ? true : false}
                                            />
                                            <img
                                                src="Images/Policy/sort-up.svg"
                                                className="hive-table-sort"
                                                id="acknowlegment_status@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'acknowlegment_status@DESC' ? false : true}
                                            />
                                        </th>
                                        <th>
                                            Acknowledged On
                                            <img src="Images/Policy/sort-down.svg" alt="sort-down" className="cursor-pointer"
                                                id="modified_at@DESC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'modified_at@DESC' ? true : false}
                                            />
                                            <img
                                                src="Images/Policy/sort-up.svg"
                                                className="hive-table-sort"
                                                id="modified_at@ASC"
                                                onClick={(e) => sortClicked(e)}
                                                hidden={sorthide == 'modified_at@DESC' ? false : true}
                                            />

                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="regular-text font-12">
                                    {/* <tr>
                                        <td>General Regulations</td>
                                        <td>12/08/2022</td>
                                        <td>No</td>
                                        <td>NA</td>
                                        <td>
                                            <button type="button" className="btn btn-policy-edit box-shadow-none">
                                                <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>General Regulations</td>
                                        <td>12/08/2022</td>
                                        <td>Yes</td>
                                        <td>12/08/2022</td>
                                        <td>
                                            <button type="button" className="btn btn-policy-edit box-shadow-none">
                                                <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>General Regulations</td>
                                        <td>12/08/2022</td>
                                        <td>No</td>
                                        <td>12/08/2022</td>
                                        <td>
                                            <button type="button" className="btn btn-policy-edit box-shadow-none">
                                                <img src="Images/Policy/eye-icon-policy.svg" alt="eye-icon-policy" />
                                            </button>
                                        </td>
                                    </tr> */}
                                </tbody>
                                {bindIndividualPolicyDirectory()}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}